export default {
  Token: {
    token: 'Token',
    trending: 'Trending',
    graduated: 'Graduated',
    quickBuy: 'Quick Buy',
    filterRisk: 'Filter Risk',
    select: 'Select',
    liquidity: 'Liquidity',
    marketCap: 'Market Cap',
    holder: 'Holders',
    price: 'Price',
    all: 'All',
    devHold: 'DEV Hold',
    devSellAll: 'DEV Sell All',
    devBunt: 'DEV Bunt',
    action: 'Action',
    holding: 'Holding',
    chg: 'Chg',
    balance: 'Balance',
    '7D': '7D',
    '30D': '30D',
    deposit: 'Deposit',
    amount: 'Amount',
    vol: 'Vol',
    mc: 'MC',
    watchList: 'Watchlist',
    newCreations: 'New Creations',
    aboutToGraduate: 'About to Graduate',
    status: 'Status',
    migrating: 'Migrating',
    signals: 'Signals',
    treasures: 'Treasures',
  },
  Base: {
    nodata: 'No Data...',
    depositFund: 'Deposit Funds',
    depositFundText: 'Scan the QR code or copy the address to add funds',
    depositFundTextTips: '(Only accepts assets on the {{chain}})',
    withdrawFund: 'Withdraw Funds',
    withdraw: 'Withdraw',
    available: 'Available:',
    all: 'All',
    enterAddress: 'Enter Address',
    confirmWithdraw: 'Confirm Withdraw',
    withdrawTips: ' Please confirm whether to transfer the funds. Wrong address will not be restored.',
    sendTips: 'You will send <0>{{amount}} {{symbol}}</0> to the following address',
    share: 'Share',
    enterAmount: 'Enter Amount',
    pleLogin: 'Please log in first',
    cancel: 'Cancel',
    login: 'Login',
    copyAddress: 'Copy Address',
    copySuccessful: 'Copy successful',
    noPermission: 'No permission',
    invalidAddressTips: 'Please enter EVM(Solana) address',
  },
  Address: {
    '30DPnL': '30D PnL',
    '7DPnL': '7D PnL',
    last7DPnl: 'Last 7D PnL',
    last30DPnl: 'Last 30D PnL',
    share: 'Share',
    profit: 'Profit',
    distribution: 'Distribution',
    winRate: 'Win Rate',
    solBalance: 'SOL Balance',
    totalPnL: 'Total PnL',
    unrealizedProfit: 'Unrealized Profit',
    pnL: 'PnL',
    '7dToastCost': '7D Toast Cost',
    '7dTokenAvgCost': '7D Token Avg Cost',
    '7dTokenRealizedAvgCost': '7D Token Avg Realized Profits',
    '7dBuyTokens': '7D Buy Tokens',
    '30dToastCost': '30D Toast Cost',
    '30dTokenAvgCost': '30D Token Avg Cost',
    '30dTokenRealizedAvgCost': '30D Token Realized Avg Cost',
    '30dBuyTokens': '30D Buy Tokens',
    recentPnl: 'Recent PnL',
    holdings: 'Holdings',
    activity: 'Activity',
    history: 'History',
    '7dRealizedProfit': '7D Realized Profit',
    '30dRealizedProfit': '30D Realized Profit',
    totalProfit: 'Total Profit',
    token: 'Token',
    tokenLastActive: 'Token/Last Active',
    unrealized: 'Unrealized',
    realizedProfit: 'Realized Profit',
    balance: 'Balance',
    position: 'Position',
    bought: 'Bought',
    sold: 'Sold',
    avg: 'Avg',
    '30DTxs': '30D TXs',
    hideSmallAssets: 'Hide Small Assets',
    hideSellOut: 'Hide Sell Out',
    type: 'Type',
    total: 'Total',
    amount: 'Amount',
    price: 'Price',
    time: 'Time',
    withdraw: 'Withdraw',
    deposit: 'Deposit',
    active: 'Active',
    success: 'Success',
    cancel: 'Cancel',
    from: 'From',
    to: 'To',
  },
  Header: {
    revokeDelegate: 'Revoke Delegate',
    approveDelegate: 'Approve Delegate',
    logout: 'Logout',
    exportWallet: 'Export Wallet',
    referral: 'Referral',
    watchList: 'Watch List',
    language: 'Language',
    search: 'Search',
    searchHistory: 'Search History',
    enterContractToken: 'Enter Contract/Token',
    dayTrending: '24H Trending',
    darkMode: 'Dark Mode',
    advanced: 'Advanced',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    buy: 'Buy',
  },
  SmartTag: {
    all: 'All',
    bargainHunter: 'Bargain Hunter',
    topEscapeMaster: 'Top Escape Master',
    heavyPositionsMaster: 'Heavy Positions Master',
    pumpfunHunter: 'Pumpfun Hunter',
    diamondHand: 'Diamond Hand',
    alwaysWrong: 'Always wrong',
    newAddress: 'New Address',
  },
  Tabbar: {
    token: 'Token',
    smart: 'Smart',
    trade: 'Trade',
    account: 'Account',
    signal: 'Signal',
    watchList: 'WatchList',
  },
  Trade: {
    balanceD: 'Balance:',
    slippageD: 'Slippage:',
    priorityFeeD: 'priorityFee:',
    setting: 'Setting',
    auto: 'Auto',
    mevProtection: 'MEV Protection',
    TakeProfitAndStopLoss: 'Take Profit & Stop Loss',
    insufficientBalanceRecharge: 'Balance not enough, please recharge',
    amountCannotBeZero: 'Amount not zero',
    enterAmount: 'Input amount',
    insufficientBalance: 'Insufficient balance, to Deposit',
    insufficientBalanceNoGas: 'Insufficient balance for gas fees.',
    buy: 'Buy',
    sell: 'Sell',
    market: 'Market',
    limit: 'Limit',
    reservedBalanceTooFew: 'Insufficient SOL balance to cover the Gas fee.',
    quantity: 'Quantity',
    value: 'Value',
    allTimeGains: 'All Time Gains',
    currentPNL: 'Current PNL',
    position: 'Position',
    myOrder: 'My Orders',
    activity: 'Activity',
    unrealized: 'Unrealized',
    realizedProfit: 'Realized Profit',
    BoughtAndAvg: 'Bought/Avg',
    totalProfit: 'Total Profit',
    balance: 'Balance',
    type: 'Type',
    price: 'Price',
    total: 'Total',
    amount: 'Amount',
    maker: 'Maker',
    time: 'Time',
    slippageTips: ' The sliding point cannot exceed 30%',
    priorityFeeTips: ' The priority fee cannot exceed 0.2 SOL ',
    never: 'Never',
    '10min': '10 Minutes',
    '1hour': '1 Hour',
    '1day': '1 Day',
    '3day': '3 Days',
    '7day': '7 Days',
    '30day': '30 Days',
    cancel: 'Cancel',
    createWhen: 'Created When',
    targetPrice: 'Target Price',
    status: 'Status',
    condition: 'Condition',
    priceIncrease: 'Price increase',
    priceDrop: 'Price drop',
    limitPriceNotZero: 'Limit price cannot be zero',
    limitPriceNotEmpty: 'Limit price cannot be empty',
    limitAmountNotGtBalance: 'Limit cannot exceed balance.',
    totalPriceNotLt10: 'Order total must be at least 10 USDT.',
    priceInUSD: 'Priced in USD',
    expiry: 'Expiry',
    dropChgNoGte100: 'Drop change must be less than 100%',
    expiration: 'Expiration',
    active: 'Active',
    success: 'Success',
    canceled: 'Canceled',
    insufficientFunds: 'Insufficient funds',
    buyIn: 'Buy',
    sellOut: 'Sell',
    mcap: 'MCap',
    liq: 'Liq',
    '24hVol': '24h Vol',
    holders: 'Holders',
    holding: 'Holding',
    orders: 'Orders',
    chart: 'Chart',
    info: 'Info',
    marketInfo: 'Market Info',
    liquidity: 'Liquidity',
    marketCap: 'Market Cap',
    createdAt: 'Created At',
    '24hVolume': '24h Volume',
    volumes: 'VOLUMES',
    makers: 'MAKERS',
    buys: 'BUYS',
    sells: 'SELLS',
    buyVol: 'BUY VOL',
    sellVol: 'SELL VOL',
    buyers: 'BUYERS',
    sellers: 'SELLERS',
    login: 'Login',
    slippageLowTips: 'Slippage too low may fail the trade. Set it between 0.1% and 80%.',
    slippageZeroTips: 'Slippage should not be 0%. Set it between 0.1% and 80%.',
    slippageExceedTips: '	Slippage should not exceed 80%. Set it between 0.1% and 80%.',
    solPriorityFeeLowTips: 'A low priority fee may slow down execution. Set it between 0.012 and 2 SOL.',
    solPriorityFeeExceedTips: 'Priority fee should not exceed 2 SOL. Set it between 0.012 and 2 SOL.',
    bscGasFeeLowTips: 'A low gas fee may cause slow execution. It is recommended to set it between 1 and 20 Gwei.',
    bscGasFeeExceedTips: 'A high gas fee may result in excessive costs. It is recommended to set it between 1 and 20 Gwei.',
    slippage: 'Slippage',
    priorityFee: 'Priority Fee',
    confirm: 'Confirm',
    AntiMEV: 'Anti-MEV',
    close: 'Close',
    percent: '%',
    sellAll: 'Sell All',
    authorize: 'Authorize',
    gasFee: 'Gas Fee',
  },
  Smart: {
    smartMoney: 'Smart Money',
    notification: 'Notification',
    users: 'Users',
    quickBuy: 'Quick Buy',
    '7d': '7D',
    '30d': '30D',
    '7dWinRate': '7D Win Rate',
    '7dRoi': '7D ROI',
    '7dPnL': '7D PnL',
    '30dWinRate': '30D Win Rate',
    '30dRoi': '30D ROI',
    '30dPnL': '30D PnL',
  },
  Follow: {
    follow: 'Follow',
    smartMoney: 'Smart Money',
    tokens: 'Tokens',
    vol: 'VOL',
    mc: 'MC',
    chg: 'Chg',
    price: 'Price',
  },
  Referral: {
    referralText: 'Earn <0>30%</0> of your referrals’ fees and <0>5%</0> of their referrals’ fees',
    invitationLink: 'Referral Link',
    availableRewards: 'Available rewards',
    claimedRewards: 'Claimed rewards ',
    totalReferrals: 'Total referrals',
    points: 'Points',
    myReferrals: 'My Referrals',
    withdrawTips: 'Withdrawals can only be made when the commission is greater than $50.',
    pointTips:
      'Trade $1 to earn 100 points. Points can be used in the future to redeem more value-added services on the platform or potential airdrops.',
    wallet: 'Wallet',
    volume: 'Volume',
    rewards: 'Rewards',
    referralOverview: 'Referral Overview',
    withdraw: 'Withdraw',
    ambassadorProgram: 'Ambassador Program',
    ambassadorProgramTips: 'Apply for the Ambassador Program to earn higher commissions',
    apply: 'Apply',
  },
  Account: {
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    holding: 'Holding',
    activity: 'Activity',
    history: 'History',
    type: 'Type',
    time: 'Time',
    token: 'Token',
    value: 'Value',
    price: 'Price',
    all: 'All',
    buy: 'Buy',
    sell: 'Sell',
    unrealizedProfit: 'Unrealized Profit',
    balance: 'Balance',
    to: 'to',
    from: 'from',
    maker: 'Maker',
    address: 'Address',
  },
  Signal: {
    price: 'Price',
    mc: 'MCap',
    liquidity: 'Liquidity',
    holders: 'Holders',
    alert: 'Alert',
    now: 'Now',
    safe: 'Safe',
    noMint: 'No Mint',
    blackList: 'Blacklist',
    burnt: 'Burnt',
    totalProfit: 'Total Profit',
    bought: 'Bought',
    time: 'Time',
    alertMaxChg: 'The maximum increase after the first alert was <0>{{value}}<0/>',
    wallet: 'Wallet',
    setting: 'Setting',
    mergeSignals: 'Merge Signals',
    mevProtection: 'MEV protection',
    slippage: 'Slippage',
    auto: 'Auto',
    priorityFee: 'Priority Fee',
    amountQuickBuy: 'Amount of Quick Buy({{symbol}})',
    percentQuickSell: 'Percentage of Quick Sell',
    cancel: 'Cancel',
    confirm: 'Confirm',
    top10: 'Top10',
    alertTips: 'The <0>{{count}}</0> alert was <0>{{time}}</0>',
    token: 'Token',
    alertTime: 'Alert Times',
    maxIncrease: 'Max Increase',
    notBalance: 'Insufficient Balance',
    tutorial: 'Tutorial',
    howItWorks: 'How it works?',
    signalFilter: 'Signal Filter',
    signalAlertTimes: 'Signal Alert Times',
    reset: 'Reset',
    apply: 'Apply',
    pushTimesTips: 'The <0>{{ordinal}}</0> alert for the current meme',
    search: 'Search',
    risk: 'Risk',
    openSource: 'Open Source',
    honeypot: 'Honeypot',
    renounced: 'Renounced',
    gasFee: 'Gas Fee',
  },
};
